import React from 'react';
import {Spacing} from '@vkontakte/vkui';
import {Logotype} from "./Logotype";
import {Rating} from "./Rating";
import StartButton from "./StartButton";
import BackgroundLetters from "../../components/Background/Background";
import DailyBonus from "./DailyBonus";
import MissionsBanner from "./MissionsBanner";
import TournamentBanner from "./TournamentBanner";
import RecommendBanner from "../../components/RecommendBanner/RecommendBanner";
import ModalTestPanel from "./ModalTestPanel";

function Home() {
    return (
        <>
            <BackgroundLetters />
            {/* Контейнер ограничен по ширине, чтобы совпадал с колонкой рейтинга */}
            <div className={"relative z-10 flex flex-col p-4 items-center mx-auto w-full max-w-lg"}>
                <Spacing size={12}/>
                <div className={"w-full"}><Logotype/></div>
                <Spacing size={32}/>
                <div className={"w-full"}><StartButton/></div>
                <Spacing size={12}/>
                <div className={"w-full"}><DailyBonus /></div>
                <Spacing size={12}/>
                <div className={"w-full"}><MissionsBanner/></div>
                <Spacing size={12}/>
                <div className={"w-full"}><TournamentBanner/></div>
                {/* Разблокировать после публикации в каталоге */}
                {/*<Spacing size={12}/>*/}
                {/*<div className={"w-full"}><RecommendBanner/></div>*/}
                <Spacing size={12}/>
                <div className={"w-full"}><Rating/></div>
                <Spacing size={12}/>
                <div className={"w-full"}>
                    <ModalTestPanel />
                </div>
            </div>
        </>
    );
}

export default Home;
